import React, { useEffect } from 'react';
import { Alert, InputGroupText } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Form, Field } from '@availity/form';
import * as yup from 'yup';
import '@availity/yup';
import * as authActions from '../../store/auth/actions';
import AuthShell from '../../components/Common/AuthShell';

const Login = (props) => {
  const error = useSelector((state) => state.Auth.error);
  const success = useSelector((state) => state.Auth.success);
  const loading = useSelector((state) => state.Auth.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.resetMessages());
  }, []);

  const handleValidSubmit = ({ email, password }) => {
    dispatch(authActions.loginWithEmail(email, password, props.history));
  };

  const handleLoginWithGoogle = () => {
    dispatch(authActions.loginWithGoogle(props.history));
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Sign in to continue with your agents and your team."
      footer={
        <p className="mb-0">
          Don't have an account?{' '}
          <Link to="/register" className="font-weight-medium text-primary">
            Sign up
          </Link>
        </p>
      }
    >
      {error !== '' && <Alert color="danger">{error}</Alert>}
      {success !== '' && <Alert color="success">{success}</Alert>}
      <Form
        initialValues={{
          email: '',
          password: '',
        }}
        onSubmit={handleValidSubmit}
        validationSchema={yup.object().shape({
          email: yup.string().email().required(),
          password: yup.string().required(),
        })}
      >
        <Field
          name="email"
          label="Email"
          type="email"
          placeholder="Enter email"
          prepend={
            <InputGroupText>
              <i className="bx bx-envelope"></i>
            </InputGroupText>
          }
        />
        <Field
          name="password"
          label="Password"
          type="password"
          placeholder="Enter Password"
          prepend={
            <InputGroupText>
              <i className="bx bx-lock-alt"></i>
            </InputGroupText>
          }
        />
        <div className="d-flex flex-wrap align-items-center justify-content-between">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="customControlInline"
            />
            <label
              className="custom-control-label"
              htmlFor="customControlInline"
            >
              Remember me
            </label>
          </div>
          <Link to="/forgot-password" className="text-muted">
            <i className="bx bx-lock-open-alt align-middle mr-1"></i>
            Forgot password?
          </Link>
        </div>
        <button
          className="btn btn-primary btn-block waves-effect waves-light mt-4 py-2"
          type="submit"
          disabled={loading}
        >
          {/* The spinner takes the icon's place rather than joining it, so
              the label does not shift while the sign-in is in flight. */}
          <i
            className={`bx ${
              loading ? 'bx-loader bx-spin' : 'bx-log-in'
            } font-size-16 align-middle mr-2`}
          ></i>
          Sign in
        </button>
        <div className="auth-divider my-4">
          <span>or</span>
        </div>
        <button
          className="btn btn-outline-dark btn-block waves-effect waves-light py-2"
          type="button"
          onClick={handleLoginWithGoogle}
          disabled={loading}
        >
          <i className="bx bxl-google font-size-16 align-middle mr-2"></i>
          Sign in with Google
        </button>
      </Form>
    </AuthShell>
  );
};

export default withRouter(Login);
